import * as React from 'react';

interface ProductsGridContextRefProviderProps {
  scrollToRef(): void;
  setRef(ref: React.RefObject<HTMLElement>): void;
}
export const ProductsGridRefContext =
  React.createContext<ProductsGridContextRefProviderProps>({} as any);

export const useProductsGridRefContext = () =>
  React.useContext(ProductsGridRefContext);

export const ProductsGridRefContextProvider: React.FC = ({ children }) => {
  const [ref, setRef] = React.useState<React.RefObject<HTMLElement>>(
    null as any,
  );

  const scrollToRef = () => {
    ref?.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <ProductsGridRefContext.Provider
      value={{
        scrollToRef,
        setRef,
      }}
    >
      {children}
    </ProductsGridRefContext.Provider>
  );
};
